import $ from 'jquery';
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Router from "./components/GlobalComponents/AppRouter";
import { images } from "./utils/imagesToLoad";
import './App.scss';
import { FormProvider } from './FormContext';
import FormModal from './components/GlobalComponents/FormModal/FormModal';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      }
      newImage.onerror = (err) => reject(err);
    });
  };
  useEffect(() => {
    if (isLoading) {
      $('body').addClass("ovf-hidden");
    }
    Promise
      .all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => console.log("Failed to load images", err));
  }, []);
  useEffect(() => {
    if (!isLoading) {
      $('body').removeClass("ovf-hidden");
      $('#loader').addClass("hide");
    }
  }, [isLoading]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <HelmetProvider>
      <FormProvider>
        <BrowserRouter>
          <Router />
          <FormModal />
        </BrowserRouter>
      </FormProvider>
    </HelmetProvider>
  );
}

export default App;
